import { z } from 'zod';
import { route, defineContract } from '../core/types';
import { requiredStringSchema } from '../schemas';
import { issuesSortingSettingsSchema } from '@shared/interfaces/IIssuesSortingSettings';

// ============================================================
// Param Schemas
// ============================================================

const projectParamsSchema = z.object({
	projectId: requiredStringSchema,
});

// ============================================================
// Body Schemas
// ============================================================

const upsertSortingSettingsBodySchema = z.object({
	byProfession: z.array(z.string()).optional(),
	byAssignee: z.array(z.string()).optional(),
});

// ============================================================
// Contract
// ============================================================

/**
 * A per-project singleton: the project is the whole identity, so the resource has
 * no id of its own. Registered at the service root because the URI is addressed
 * from the project down, not from the resource name down.
 */
export const sortingSettingsContract = defineContract(
	'sortingSettings',
	{
		getSortingSettings: route({
			method: 'GET',
			path: '/projects/:projectId/sortingSettings',
			params: projectParamsSchema,
			response: issuesSortingSettingsSchema.nullable(),
			operationId: 'getSortingSettings',
			tags: ['Sorting Settings'],
			summary: 'Get the issue sorting settings of a project',
		}),
		upsertSortingSettings: route({
			method: 'PUT',
			path: '/projects/:projectId/sortingSettings',
			params: projectParamsSchema,
			body: upsertSortingSettingsBodySchema,
			response: issuesSortingSettingsSchema,
			operationId: 'upsertSortingSettings',
			tags: ['Sorting Settings'],
			summary: 'Create or update the issue sorting settings of a project',
		}),
	},
	{ root: true }
);
